export type SolisecoModel =
  | '1P_Intraheat'
  | '1P_Extraheat'
  | '3P_Extraheat'
  | '1P_SG_Ready';

export function isTriPhaseDevice(device: { soliseco_model?: string } | null | undefined): boolean {
  return typeof device?.soliseco_model === "string" && device.soliseco_model.startsWith("3P_");
}

export type Device = {
  id: number;
  created_at?: string;
  name: string;
  home: number;
  device_id: string;
  soliseco_model: SolisecoModel;
  schedule?: number[][];
  mode: string;
  running_state: string;
  sanitation_active: boolean;
  sanitation_max_period_days: number;
  sanitation_hour_start_time: number;
  sanitation_temperature: number;
  installation_phase: number;
  dropout_phase_correct: boolean;
  handle_dropout: boolean;
  dropout_period_start_time: string;
  dropout_period_end_time: string;
  dropout_v_max: number;
  dropout_v_threshold: number;
  dropout_power?: number;
  dropout_v_max_l2?: number;
  dropout_v_threshold_l2?: number;
  dropout_power_l2?: number;
  dropout_v_max_l3?: number;
  dropout_v_threshold_l3?: number;
  dropout_power_l3?: number;
  t_cold: number;
  t_lukewarm: number;
  t_hot: number;
  t_very_hot: number;
  t_max: number;
  heater_max_temp?: number;
  own_address_ip: string;
  parameter_configuration?: {
    id: number;
    name: string;
    commissioning_tip_en?: string;
    commissioning_tip_fr?: string;
    commissioning_tip_de?: string;
    commissioning_tip_nl?: string;
    advanced_device_parameters: string[];
    not_applicable_device_parameters?: string[];
    default_parameters?: Array<{ field_name: string; value: any }>;
  };
  advanced_device_parameters?: string[];
  not_applicable_device_parameters?: string[];
}

export function isDeviceDetailLoaded(
  device: Device | undefined | null
): boolean {
  return !!device && typeof device.created_at === "string";
}
